import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import AppAccess from "./AppAccess";

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AppAccess);
